import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';
import { LoginService } from 'src/app/services/login/login.service';
@Pipe({
    name: 'getDateTZPipe',
    pure: true
})
export class GetDateTZPipe implements PipeTransform {
    constructor(private loginService: LoginService) {
    }
    transform(value: number, args?: any): any {
        return this.getDateTZPipe(value)
    }
    getDateTZPipe(epoch: number): String {
        let tz = this.loginService.currentUserValue.timeZone;
        if (tz==null) {
            tz = "Europe/Madrid"
        }
        if (epoch != null) {
            const formateado =  moment.unix(Number(epoch) / Math.pow(10,9)).tz(tz).format('YYYY-MM-DD HH:mm:ss');
            return formateado;
        } else {
            return 'Sin fecha registrada';
        }
    }
    getInvalidatedDatePipe(invalidated: number): String {
        if (invalidated != null) {
            return new Date(invalidated / 1000000).toISOString();
        } else {
            return 'Sin invalidar'
        }

    }
}